const primarySignupTypes = {
  1: 'Email',
  2: 'Phone',
  3: 'Email & Phone'
};

export default primarySignupTypes;
